// extracted by mini-css-extract-plugin
module.exports = {"selectWrapper":"Select_selectWrapper__-aKSl","icon":"Select_icon__1NzIV"};